export default __webpack_public_path__ + "static/media/search.d2cf3a1b.svg";